<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.limit_target_type"
        placeholder="限制目标类型"
        clearable
        style="width: 150px"
        class="filter-item"
        size="small"
      />
      <el-input
        v-model="listQuery.config_key"
        placeholder="配置键"
        clearable
        style="width: 130px"
        class="filter-item"
        size="small"
      />
      <el-select
        v-model="listQuery.target_type"
        placeholder="供应商来源"
        clearable
        style="width: 130px"
        class="filter-item"
        size="small"
      >
        <el-option
          v-for="item in targetTypeOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-select
        v-model="listQuery.is_enabled"
        placeholder="状态"
        clearable
        style="width: 100px"
        class="filter-item"
        size="small"
      >
        <el-option label="启用" value="1" />
        <el-option label="禁用" value="0" />
      </el-select>
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        size="small"
        >搜索</el-button
      >
      <el-button
        class="filter-item"
        icon="el-icon-refresh"
        @click="handleReset"
        size="small"
        >重置</el-button
      >
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-plus"
        @click="handleCreate"
        size="small"
        v-if="$canEdit"
        >新增</el-button
      >
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
      size="small"
    >
      <el-table-column align="center" label="ID" width="80">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column label="客户端ID" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.app_client_id }}
        </template>
      </el-table-column>
      <el-table-column label="客户端名称" min-width="150" align="center">
        <template slot-scope="scope">
          {{ scope.row.app_client?.name || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="限制目标类型" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.limit_target_type || '-' }}
        </template>
      </el-table-column>

      <el-table-column label="配置键" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.config_key || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="状态" min-width="80" align="center">
        <template slot-scope="scope">
          <el-switch
            :value="scope.row.is_enabled == 1"
            @change="handleStatusChange(scope.row)"
          />
        </template>
      </el-table-column>
      <el-table-column label="供应商来源" min-width="100" align="center">
        <template slot-scope="scope">
          <el-tag :type="getTargetTypeTagType(scope.row.target_type)">
            {{ getTargetTypeName(scope.row.target_type) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="允许产品类型" min-width="150" align="center">
        <template slot-scope="scope">
          {{ scope.row.config_value || '-' }}
        </template>
      </el-table-column>

      <el-table-column label="备注" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.remark || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="创建时间" min-width="170" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>
      <el-table-column label="更新时间" min-width="170" align="center">
        <template slot-scope="scope">
          {{ scope.row.updated_at }}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        fixed="right"
        width="150"
        v-if="$canEdit"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="handleUpdate(scope.row)"
          >
            编辑
          </el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        size="small"
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog
      :title="textMap[dialogStatus]"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-position="left"
        label-width="140px"
        style="margin-left: 30px"
      >
        <el-form-item label="客户端ID" prop="app_client_id">
          <el-input v-model="form.app_client_id" disabled />
        </el-form-item>
        <el-form-item label="限制目标类型" prop="limit_target_type">
          <el-input
            v-model="form.limit_target_type"
            placeholder="如：hotel_status"
          />
        </el-form-item>
        <el-form-item label="供应商来源" prop="target_type">
          <el-select v-model="form.target_type" placeholder="请选择">
            <el-option
              v-for="item in targetTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="配置键" prop="config_key">
          <el-input v-model="form.config_key" placeholder="如：product_type" />
        </el-form-item>
        <el-form-item label="允许产品类型" prop="config_value">
          <el-input
            v-model="form.config_value"
            placeholder="多个产品类型用英文逗号分隔，如：1,2,3"
          />
        </el-form-item>
        <el-form-item label="状态" prop="is_enabled">
          <el-select v-model="form.is_enabled" placeholder="请选择">
            <el-option label="启用" :value="1" />
            <el-option label="禁用" :value="0" />
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" type="textarea" :rows="3" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import { fetchTargetTypes, getTargetTypeName, getTargetTypeTagType } from '@/utils/targetType'
export default {
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      appClientId: null,
      listQuery: {
        page: 1,
        limit: 10,
        app_client_id: undefined,
        limit_target_type: undefined,
        target_type: undefined,
        config_key: undefined,
        is_enabled: undefined,
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '新增',
      },
      targetTypeOptions: [],
      form: {
        id: undefined,
        app_client_id: undefined,
        limit_target_type: undefined,
        target_type: undefined,
        config_key: undefined,
        config_value: undefined,
        is_enabled: 1,
        remark: undefined,
      },
      rules: {
        app_client_id: [
          { required: true, message: '客户端ID不能为空', trigger: 'blur' },
        ],
        limit_target_type: [
          { required: true, message: '请选择限制目标类型', trigger: 'change' },
        ],
        target_type: [
          { required: true, message: '请选择供应商来源', trigger: 'change' },
        ],
        config_key: [
          { required: true, message: '请选择配置键', trigger: 'change' },
        ],
        config_value: [
          { required: true, message: '请输入允许产品类型', trigger: 'blur' },
        ],
        is_enabled: [
          { required: true, message: '请选择状态', trigger: 'change' },
        ],
      },
      btnLoading: false,
    }
  },
  async created() {
    this.appClientId = this.$route.query.app_client_id
    if (this.appClientId) {
      this.listQuery.app_client_id = parseInt(this.appClientId)
    }
    this.getList()
    this.targetTypeOptions = await fetchTargetTypes()
  },
  methods: {
    getTargetTypeName: getTargetTypeName,
    getTargetTypeTagType: getTargetTypeTagType,
    getList() {
      this.listLoading = true
      const params = { ...this.listQuery }
      if (params.app_client_id === '') {
        params.app_client_id = undefined
      }
      request({
        url: '/api/backend/app-client-limit/list',
        method: 'get',
        params,
      }).then((response) => {
        this.list = response.data.data
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleReset() {
      this.listQuery = {
        page: 1,
        limit: 10,
        app_client_id: this.appClientId,
        limit_target_type: undefined,
        target_type: undefined,
        config_key: undefined,
        is_enabled: undefined,
      }
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    resetForm() {
      this.form = {
        id: undefined,
        app_client_id: this.appClientId,
        limit_target_type: undefined,
        target_type: undefined,
        config_key: undefined,
        config_value: undefined,
        is_enabled: 1,
        remark: undefined,
      }
    },
    handleCreate() {
      this.resetForm()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
    handleUpdate(row) {
      this.form = Object.assign({}, row)
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
    handleDelete(row) {
      this.$confirm('确定要删除该配置吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/app-client-limit/delete',
            method: 'post',
            data: { id: row.id },
          }).then(() => {
            this.$message({
              type: 'success',
              message: '删除成功',
            })
            this.getList()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    handleStatusChange(row) {
      const newStatus = row.is_enabled == 1 ? 0 : 1
      const statusText = newStatus === 1 ? '启用' : '禁用'
      this.$confirm(`确定要${statusText}该配置吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/app-client-limit/change-status',
            method: 'post',
            data: { id: row.id, is_enabled: newStatus },
          })
            .then(() => {
              row.is_enabled = newStatus
              this.$message({
                type: 'success',
                message: '状态更新成功',
              })
            })
            .catch(() => {
              this.$message({
                type: 'error',
                message: '状态更新失败',
              })
            })
        })
        .catch(() => {
          // 取消操作，不做处理
        })
    },
    saveData() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.btnLoading = true
          request({
            url: '/api/backend/app-client-limit/store',
            method: 'post',
            data: this.form,
          })
            .then(() => {
              this.btnLoading = false
              this.dialogFormVisible = false
              this.$notify({
                title: '成功',
                message: '保存成功',
                type: 'success',
                duration: 2000,
              })
              this.getList()
            })
            .catch(() => {
              this.btnLoading = false
            })
        }
      })
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped></style>
